import {
  Icon,
  IconButton,
  Button,
  Shadow,
  Text,
  SliderModal,
  HStack,
  VStack,
} from '@genial/components';
import { Box, ScrollView } from 'native-base';
import React, { useMemo, useState } from 'react';
import { Modal } from 'react-native';

import { RecommendedPortfolioBadge } from '../../../../../../../components/RecommendedPortfolioBadge';
import { StrategyAssetsQueryItem } from '../../../../../../../store/customerAssetDetail/types';
import { IDynamicProductSearchItem } from '../../../_dynamic';
import { ProfitabilityText } from '../ProfitabilityText';

export const ProductItemMobile: React.FC<IDynamicProductSearchItem<StrategyAssetsQueryItem>> = ({
  item,
}) => {
  const [detailsOpen, setDetailsOpen] = useState(false);

  const itemInfo = useMemo(() => {
    const fields = [
      {
        label: 'Tipo',
        value: <Text>{item.typeNameNormalized}</Text>,
      },
      {
        label: 'Valor Bruto',
        value: <Text>{item.grossValueNormalized}</Text>,
      },
      {
        label: 'Valor Líquido',
        value: <Text>{item.netValueNormalized}</Text>,
      },
    ];

    const labelsWithValues = fields.map((label) => {
      return (
        <VStack space="stack.quarck" key={label.label} flex={1}>
          <Text variant="bold">{label.label}</Text>
          <Text>{label.value}</Text>
        </VStack>
      );
    });

    return (
      <VStack width="full" space="stack.xxxs">
        <HStack
          justifyContent="space-between"
          alignItems="center"
          width="full"
          borderBottomColor="neutral.light"
          borderBottomWidth={1}
          paddingBottom="inset.xs">
          <Text fontSize="md" variant="semibold" testId="product-item-tablet-name">
            {item.assetNameNormalized}
          </Text>
          <RecommendedPortfolioBadge
            hasRecommendedPortfolioLink={item.hasRecommendedPortfolioLink}
            recommendedPortfolioLinks={item.recommendedPortfolioLinks}
          />
        </HStack>
        <HStack width="full">{labelsWithValues}</HStack>
      </VStack>
    );
  }, [item]);

  const itemRentabilityAndDue = useMemo(() => {
    const fields = [
      {
        label: 'Rendimentos(12m)',
        value: <ProfitabilityText profitability={item.profitability} />,
      },
      {
        label: 'Valor Bruto',
        value: <Text>{item.grossValueNormalized}</Text>,
      },
      {
        label: 'Vencimento',
        value: <Text>{item.maturityDateNormalized}</Text>,
      },
    ];

    const labelsWithValues = fields.map((label) => {
      return (
        <HStack justifyContent="space-between" space="stack.quarck" key={label.label} flex={1}>
          <Text>{label.label}</Text>
          <Text>{label.value}</Text>
        </HStack>
      );
    });

    return (
      <VStack space="stack.nano" width="full">
        {labelsWithValues}
      </VStack>
    );
  }, [item]);

  const itemPaymentHistory = useMemo(() => {
    if (!item.paymentHistoryNormalized.length) {
      return null;
    }

    const history = item.paymentHistoryNormalized.map((entry, index) => {
      const fields = [
        {
          label: 'Data',
          value: <Text>{entry.dateNormalized}</Text>,
        },
        {
          label: 'Evento',
          value: <Text>{entry.eventNormalized}</Text>,
        },
        {
          label: 'Valor',
          value: <Text>{entry.valueNormalized}</Text>,
        },
      ];

      const labelsWithValues = fields.map((label) => {
        return (
          <HStack justifyContent="space-between" space="stack.quarck" key={label.label} flex={1}>
            <Text>{label.label}</Text>
            <Text>{label.value}</Text>
          </HStack>
        );
      });

      return (
        <VStack space="stack.nano" width="full" key={index.toString()}>
          {labelsWithValues}
        </VStack>
      );
    });

    return (
      <VStack space="stack.nano" padding="inset.sm" borderRadius="md" backgroundColor="background">
        {history}
      </VStack>
    );
  }, [item]);

  const handleDetails = () => {
    setDetailsOpen(!detailsOpen);
  };

  return (
    <Shadow level={1} borderRadius="xs" width="full" padding="inset.xs">
      <Box
        position="absolute"
        top={0}
        left={0}
        bottom={0}
        w="4px"
        backgroundColor={item.productColor}
        borderTopLeftRadius="full"
        borderBottomLeftRadius="full"
      />
      <VStack width="full" space="stack.xxxs">
        {itemInfo}
        <Button
          alignSelf="flex-end"
          rightIcon={<Icon name="ArrowRight" size="xxxs" color="brand.tertiary.principal" />}
          onPress={handleDetails}
          variant="textLink">
          MAIS DETALHES
        </Button>
      </VStack>
      <Modal transparent style={{ flex: 1 }} visible={detailsOpen} animationType="slide">
        <SliderModal direction="top" onDismiss={handleDetails}>
          <Shadow level={1} borderTopRadius="md" width="full" padding="inset.xs">
            <ScrollView flex={1}>
              <VStack width="full" space="stack.xxs">
                <HStack justifyContent="space-between" alignItems="center">
                  <Text variant="semibold" fontSize="lg">
                    Detalhes da posição
                  </Text>
                  <IconButton
                    icon="Close"
                    iconColor="neutral.medium"
                    iconSize="xxxs"
                    onPress={handleDetails}
                    testId="product-item-mobile-close"
                  />
                </HStack>
                <Shadow level={1} borderRadius="xs" width="full" padding="inset.nano">
                  {itemInfo}
                </Shadow>
                {itemRentabilityAndDue}
                {itemPaymentHistory}
              </VStack>
            </ScrollView>
          </Shadow>
        </SliderModal>
      </Modal>
    </Shadow>
  );
};
